import React from "react";
import clsx from "clsx";
import { format, parseISO } from "date-fns";

import { IconButton, Paper, Typography, makeStyles } from "@material-ui/core";
import Edit from "@material-ui/icons/Edit";
import DeleteOutline from "@material-ui/icons/DeleteOutline";

import { i18n } from "../../translate/i18n";

const useStyles = makeStyles((theme) => ({
  card: {
    position: "relative",
    padding: theme.spacing(1.5, 2),
    borderRadius: theme.borderRadius.medium,
    borderLeft: "5px solid",
  },
  low: { borderLeftColor: theme.palette.grey[400] },
  normal: { borderLeftColor: theme.palette.primary.main },
  high: {
    borderLeftColor: theme.palette.error.main,
    backgroundColor: theme.palette.type === "dark" ? "#3B1D24" : "#FDECEC",
  },
  inactive: {
    opacity: 0.55,
  },
  header: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
  },
  title: {
    flex: 1,
    fontWeight: 600,
  },
  pill: {
    padding: "1px 8px",
    borderRadius: theme.borderRadius.pill,
    fontSize: 11,
    fontWeight: 500,
    backgroundColor: theme.palette.action.selected,
  },
  text: {
    marginTop: theme.spacing(0.5),
    whiteSpace: "pre-wrap",
  },
  meta: {
    marginTop: theme.spacing(0.5),
    color: theme.palette.text.secondary,
  },
}));

// Usado na página de Informativos e no topo do Dashboard
const AnnouncementCard = ({ announcement, onEdit, onDelete, compact }) => {
  const classes = useStyles();

  return (
    <Paper
      variant="outlined"
      className={clsx(
        classes.card,
        classes[announcement.priority],
        !announcement.active && classes.inactive
      )}
    >
      <div className={classes.header}>
        <Typography variant="subtitle1" className={classes.title}>
          {announcement.title}
        </Typography>
        {!announcement.active && (
          <span className={classes.pill}>{i18n.t("announcements.inactive")}</span>
        )}
        {!compact && (
          <span className={classes.pill}>
            {i18n.t(`announcements.priority.${announcement.priority}`)}
          </span>
        )}
        {onEdit && (
          <IconButton size="small" onClick={() => onEdit(announcement)}>
            <Edit fontSize="small" />
          </IconButton>
        )}
        {onDelete && (
          <IconButton size="small" onClick={() => onDelete(announcement)}>
            <DeleteOutline fontSize="small" />
          </IconButton>
        )}
      </div>
      <Typography variant="body2" className={classes.text}>
        {announcement.text}
      </Typography>
      {!compact && (
        <Typography variant="caption" component="div" className={classes.meta}>
          {i18n.t("announcements.by", {
            name: announcement.createdBy?.name || "-",
            date: format(parseISO(announcement.createdAt), "dd/MM/yyyy HH:mm"),
          })}
        </Typography>
      )}
    </Paper>
  );
};

export default AnnouncementCard;
